module.exports = __webpack_public_path__ + "static/media/right.4d357ff9.png";